import React from "react";
import "./CheckMessage.css";

const CheckMessage = ({ color = "currentColor", width = 16, height = 16, className = "", readed = false }) => {
  const strokeWidth = readed ? 2 : 1;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 18"
      fill="none"
      className={`check-message-svg ${readed ? "read" : "sent"} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L9 14L18 5"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12L17 14L26 5"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckMessage;
